export const QUERY_STRING_PREV_STEP_OVERRIDE: string = 'mockPreviousStep';

export const REQUIRED_QUERY_PARAMS = ['oid', 'yrsp', 'yrdup', 'euid'];
export const MUSIC_PREMIUM_QUERY_STRING_VALUE = 'musicpremium';
export const YOUTUBE_GENERIC_QUERY_STRING_VALUE = 'youtube';

export const requestOrganizationConstants = {
    FEEDBACK_FORM_URL: 'https://verify.sheerid.com/verification-support/feedback.html?token=',
};

export const RETURN_TO_LANDING_REDIRECT = 'https://www.youtube.com/premium/';
export const STANDARD_LOGO = './img/premium_standard_144pt_rgb_black.png';
export const MUSIC_PREMIUM_LOGO = './img/ytp-mp-logo.svg';
export const GENERIC_LOGO = './img/youtube_generic_verification_logo.png';
